import { useDecision } from '@optimizely/react-sdk'

export const useApplyQuoteDiscount = () => {
  const [decision] = useDecision('trcc-1061')

  return decision.enabled && decision.variationKey === 'on'
}
